import {
  ADD_ON_PRICE_NOTE,
  selectedAddOns,
  type AddOnSelection,
} from '../../data/protection-addons'
import { formatCurrencyFromCents, type CeramicPackage } from '../../data/protection-catalog'
import { CERAMIC_BOOKING_DEPOSIT_CENTS } from '../../lib/booking-domain'

export interface BookSelectionSummaryProps {
  selectedPackage: CeramicPackage | null
  addOnSelection: AddOnSelection
  depositPaid?: boolean
  appointment?: { date: string; time: string } | null
  customer?: { name?: string; email?: string; phone?: string } | null
  vehicle?: { make?: string; model?: string } | null
}

export function BookSelectionSummary({
  selectedPackage,
  addOnSelection,
  depositPaid = false,
  appointment = null,
  customer = null,
  vehicle = null,
}: Readonly<BookSelectionSummaryProps>) {
  const addOns = selectedAddOns(addOnSelection)

  return (
    <aside aria-label="Current booking selection" className="book-selection-summary">
      <p className="eyebrow">Your selection</p>
      {selectedPackage ? (
        <>
          <h2>Protection</h2>
          <p>
            {selectedPackage.displayName} — {selectedPackage.productName}
          </p>
          <h3>Service price</h3>
          <p>
            From {formatCurrencyFromCents(selectedPackage.startingPriceCents)} inc. GST
          </p>
        </>
      ) : (
        <p>No protection level selected yet.</p>
      )}
      <h3>Additional protection</h3>
      {addOns.length > 0 ? (
        <ul>
          {addOns.map((item) => (
            <li key={item.id}>
              {item.name}
              <small>{ADD_ON_PRICE_NOTE}</small>
            </li>
          ))}
        </ul>
      ) : (
        <p>No additional protection</p>
      )}
      {customer?.name ? (
        <>
          <h3>Customer</h3>
          <p>
            {customer.name}
            <small>{[customer.email, customer.phone].filter(Boolean).join(' · ')}</small>
          </p>
        </>
      ) : null}
      {vehicle?.make ? (
        <>
          <h3>Vehicle</h3>
          <p>{[vehicle.make, vehicle.model].filter(Boolean).join(' ')}</p>
        </>
      ) : null}
      {appointment ? (
        <>
          <h3>Appointment</h3>
          <p>
            {appointment.date}
            <small>{appointment.time}</small>
          </p>
        </>
      ) : null}
      <h3>Due now</h3>
      <p>
        {depositPaid
          ? 'Deposit Paid — A$100'
          : `${formatCurrencyFromCents(CERAMIC_BOOKING_DEPOSIT_CENTS)} Booking Deposit`}
      </p>
    </aside>
  )
}
